import {Stack, styled} from '@mui/material';

export const StyledStack = styled(Stack)`
	flex-direction: column;
	position: relative;
	overflow-y: auto;
	display: flex;
	height: 100vh;
	flex: 1;
`;
